import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './lang/es.json';
import en from './lang/en.json';

const getInitialLanguage = () => {
    if (typeof window === 'undefined') {
        return 'es';
    }

    const storedLanguage = window.localStorage.getItem('lang');
    if (storedLanguage === 'es' || storedLanguage === 'en') {
        return storedLanguage;
    }

    const browserLanguage =
        window.navigator.languages?.[0] ||
        window.navigator.language ||
        'es';

    const normalizedLanguage = browserLanguage.toLowerCase();

    if (normalizedLanguage.startsWith('en')) {
        return 'en';
    }

    if (normalizedLanguage.startsWith('es')) {
        return 'es';
    }

    return 'es';
};

i18n.use(initReactI18next).init({
    resources: {
        es: { translation: es },
        en: { translation: en }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'es',
});

export default i18n;
